import {
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Text,
  Tag
} from '@chakra-ui/react'
import { ChangeEvent, FC, useState, useEffect } from 'react'
import { AutoResizeTextarea } from 'shared/components/chat/AutoResizeTextarea'
import { ITestContentWithText } from 'shared/types'
import map from 'lodash/map'
import trim from 'lodash/trim'

type Props = {
  test: ITestContentWithText
  onChange: (v: ITestContentWithText) => void
}

const EditTestAddWords: FC<Props> = ({ test, onChange }) => {
  const [text, setText] = useState(test.text || '')
  const [matches, setMatches] = useState<string[]>(
    (test.text || '').match(/\{(.*?)\}/g) || []
  )

  useEffect(() => {
    onChange({ ...test, text })
  }, [text])

  return (
    <VStack w='full' align={'flex-start'} spacing={4}>
      <HStack w='full'>
        <FormControl>
          <FormLabel textStyle='small' color='black' fontWeight={700}>
            Оберните нужные слова в фигурные скобки {'{вот так}'}
            <br />A указать несколько правильных ответов можно так{' '}
            {'{does / makes / creates}'}
          </FormLabel>

          <AutoResizeTextarea
            value={text}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
              setText(e.target.value)
              const m = e.target.value.match(/\{(.*?)\}/g)
              setMatches(m || [])
            }}
          />
        </FormControl>
      </HStack>
      <VStack pt={4} w='full' align='flex-start'>
        <Text textStyle='small' fontWeight={700} color='darkGray'>
          В тексте будут пропущены следующие слова:
        </Text>
        <HStack w='full' wrap={'wrap'}>
          {map(matches, (m, i) => (
            <Tag key={i} size={'sm'} variant='solid' colorScheme='teal'>
              {trim(m, '{}')}
            </Tag>
          ))}
        </HStack>
      </VStack>
    </VStack>
  )
}

export default EditTestAddWords
